//client/src/hooks/usePolicies.js
import { useState, useCallback, useEffect } from 'react';
import api from '../services/api';

export const usePolicies = () => {
    const [policies, setPolicies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchPolicies = useCallback(async () => {
        try {
            setLoading(true);
            const response = await api.get('admin/policies');
            setPolicies(response.data.data);
        } catch (err) {
            setError(err.response?.data?.error || 'Erro ao buscar políticas');
        } finally {
            setLoading(false);
        }
    }, []);

    const getPolicy = useCallback(async (id) => {
        try {
            setLoading(true);
            const response = await api.get(`admin/policies/${id}`);
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.error || 'Erro ao buscar a política');
        } finally {
            setLoading(false);
        }
    }, []);

    const createPolicy = useCallback(async (policyData) => {
        try {
            setLoading(true);
            const response = await api.post('admin/policies', policyData);
            setPolicies(prev => [...prev, response.data.data]);
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.error || 'Erro ao criar a política');
        } finally {
            setLoading(false);
        }
    }, []);

    const updatePolicy = useCallback(async (id, policyData) => {
        try {
            setLoading(true);
            const response = await api.put(`admin/policies/${id}`, policyData);
            setPolicies(prev => prev.map(p => p._id === id ? response.data.data : p));
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.error || 'Erro ao atualizar a política');
        } finally {
            setLoading(false);
        }
    }, []);

    const deletePolicy = useCallback(async (id) => {
        try {
            setLoading(true);
            await api.delete(`admin/policies/${id}`);
            setPolicies(prev => prev.filter(p => p._id !== id));
        } catch (err) {
            throw new Error(err.response?.data?.error || 'Erro ao excluir a política');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchPolicies();
    }, [fetchPolicies]);

    return {
        policies,
        loading,
        error,
        refetch: fetchPolicies,
        getPolicy,
        createPolicy,
        updatePolicy,
        deletePolicy
    };
};